// src/components/ProductsPage/packaging/requests.js
import { authFetch } from "../../api/api";

const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;

export const productsComponentsUrl = (productId) =>
  `${BASE_URL}/api/products/${productId}/components/`;

export const componentsPackagingsUrl = (componentId) =>
  `${BASE_URL}/api/components/${componentId}/packagings/`;

async function readError(response, fallback) {
  try {
    const data = await response.json();
    if (typeof data === "string") return data;
    if (data?.detail) return data.detail;
    const lines = Object.entries(data || {}).map(([k, v]) => {
      const msg = Array.isArray(v) ? v.join(", ") : String(v);
      return `${k}: ${msg}`;
    });
    return lines.join("; ") || fallback;
  } catch {
    return fallback;
  }
}

// ── Components ────────────────────────────────────────────
export async function fetchComponents(productId) {
  const r = await authFetch(productsComponentsUrl(productId));
  if (!r.ok) throw new Error(await readError(r, "Не удалось загрузить составные части"));
  const data = await r.json();
  return Array.isArray(data) ? data : data?.results ?? [];
}

export async function createComponent(productId, payload) {
  const r = await authFetch(productsComponentsUrl(productId), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!r.ok) throw new Error(await readError(r, "Не удалось создать составную часть"));
  return r.json();
}

export async function updateComponent(productId, id, payload) {
  const r = await authFetch(`${productsComponentsUrl(productId)}${id}/`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!r.ok) throw new Error(await readError(r, "Не удалось сохранить составную часть"));
  return r.json();
}

export async function deleteComponent(productId, id) {
  const r = await authFetch(`${productsComponentsUrl(productId)}${id}/`, {
    method: "DELETE",
  });
  if (!r.ok) throw new Error(await readError(r, "Не удалось удалить составную часть"));
  return true;
}

// ── Packagings ────────────────────────────────────────────
export async function fetchPackagings(componentId) {
  const r = await authFetch(componentsPackagingsUrl(componentId));
  if (!r.ok) throw new Error(await readError(r, "Не удалось загрузить упаковки"));
  const data = await r.json();
  return Array.isArray(data) ? data : data?.results ?? [];
}

export async function createPackaging(componentId, payload) {
  const r = await authFetch(componentsPackagingsUrl(componentId), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!r.ok) throw new Error(await readError(r, "Не удалось создать упаковку"));
  return r.json();
}

export async function updatePackaging(componentId, id, payload) {
  const r = await authFetch(`${componentsPackagingsUrl(componentId)}${id}/`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!r.ok) throw new Error(await readError(r, "Не удалось сохранить упаковку"));
  return r.json();
}

export async function deletePackaging(componentId, id) {
  const r = await authFetch(`${componentsPackagingsUrl(componentId)}${id}/`, {
    method: "DELETE",
  });
  if (!r.ok) throw new Error(await readError(r, "Не удалось удалить упаковку"));
  return true;
}